import { Navigate } from "react-router-dom";

const RoleProtectedRoute = ({ children, allowedRoles }) => {
  const authUser = JSON.parse(sessionStorage.getItem("authUser"));
  const role = authUser?.data?.role;

  if (!authUser) {
    return <Navigate to="/login" replace />;
  }

  if (!allowedRoles.includes(role)) {
    return <Navigate to="/dashboard" replace />; // او صفحة 403
  }

  return children;
};

export default RoleProtectedRoute;
